export default __webpack_public_path__ + "static/media/burger-menu.04e0a787.svg";